<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>
<style lang="less">
html,
body,
#app {
  width: 100%;
  height: 100%;
}

*::-webkit-scrollbar {
  display: none;
}
</style>
